// skeleton/app/src/app/home/home.component.ts

import { Constants } from 'src/app/shared/constants';

import { LogoutServive } from './../logout/logout.service';
import { AuthService } from './../auth/auth.service';
import { Router } from '@angular/router';

import { Component } from '@angular/core';
import { MenuNavbarComponent } from '../shared/components/menu-navbar/menu-navbar.component';
import { StorageService } from '../shared/services/token-storage.service';
// import { MenuNavbarComponent } from '../components/menu-navbar/menu-navbar.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false
})
export class HomeComponent {
  constant: Constants = new Constants();
  UserLoggedIn: boolean = false;
  private isExist = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private logoutservice: LogoutServive,
    private menubar: MenuNavbarComponent,
    private storage: StorageService
  ) { }

  ngOnInit() {
    if (this.authService.isTokenValid()) {

      // Use StorageService instead of sessionStorage
      let url = this.storage.get("CurrentUrl");

      if (url != null && url.length > 0) { // added for user activity log redirection
        this.router.navigateByUrl(url);
      } else { // existing code
        this.router.navigate(["/dashboard"]);
      }

      this.UserLoggedIn = true;
      this.logoutservice.changeMessage(this.UserLoggedIn);
      return;
    }
    else {
      this.logoutservice.changeMessage(this.UserLoggedIn);
      this.menubar.ngOnInit();
      this.router.navigate(['/', 'home']);
    }
  }

  navogateToOldHomePage() {
    this.router.navigate(['/', 'home']);
  }

  navigateLogIn() {
    this.router.navigate(['/', 'login']);
  }

  navigateRegister() {
    this.router.navigate(['/', 'register']);
  }
}
